/**
 * Dual-type support for mainArtists field.
 *
 * OpenSearch records contain mainArtists as either:
 * - list of strings (legacy format)
 * - list of MainArtistItem objects (new format with id, stageName, type)
 *
 * This module lives outside generated/ so it survives schema regeneration.
 */

export interface MainArtistItem {
  id: string;
  stageName: string;
  type: 'persona' | 'group';
}

/**
 * Extract display name from a mainArtists entry (handles both string and object).
 */
export function mainArtistDisplayName(item: string | MainArtistItem): string {
  return typeof item === 'string' ? item : item.stageName;
}
